import React, { useEffect, useState } from 'react';
import './StickyContactBar.css';
import { FaPhoneVolume } from 'react-icons/fa';

const StickyContactBar = () => {
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 100) {
                setIsHidden(true);
            } else {
                setIsHidden(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={`sticky-contact-bar ${isHidden ? "" : "hidden"}`}>
            Get in Touch with HANSA-FLEX Ireland
            <span className='d-flex align-items-center gap-2'>
                <FaPhoneVolume /> NI: <a href="tel:+44 028 90833813">(0044) 028 90833813 (NI)</a>
            </span>
            <span className='d-flex align-items-center gap-2'>
                <FaPhoneVolume /> ROI: <a href="tel:+353 01 6251962">(00353) 01 6251962 (ROI)</a>
            </span>
        </div>
    )
};

export default StickyContactBar; 